import { Environment } from "../app/models/interfaces/core/Environment.interface";

export const environment: Environment = {

  apiUrl: 'https://dev-sitesbuilder-eu-south-2.service.3ddvapis.com',
  apiAuthUrl: 'https://dev-auth-eu-south-2.service.3ddvapis.com',
  previewUrl: 'https://dev-preview.3ddigitalvenue.com/',
  appId: '486479',
  amenityApi: {
    baseUrl: 'https://dev-ams-eu-south-2.service.3ddvapis.com',
    version: 'v1'
  },
  contentUploaderApi: {
    baseUrl: 'https://dev-contentuploader-eu-south-2.service.3ddvapis.com',
    bucketName: 'vw-dev-sitesbuilder.eu-west-1.staticresources.3ddvfactory.com',
    accountName: 'core',
    cdnId: 'E2C9IL94XQ8I8A'
  },
  notFoundUrl: 'https://venues.3ddigitalvenue.com/notfound',
  gaMeasurementId: 'G-VFWRBDJN9P',
  cdnBucket: "https://vw-dev-sitesbuilder.eu-west-1.staticresources.3ddvfactory.com/sitesbuilder/"

};
